import React, { InputHTMLAttributes, ForwardedRef, CSSProperties } from 'react';
import { styled } from '@mui/material/styles';
import { StacklineTheme, hexToRgba, useStacklineTheme } from '@stackline/ui';
import { SxProps } from '@mui/system';

export interface SidebarInputProps extends InputHTMLAttributes<HTMLInputElement> {
  style?: CSSProperties;
  sx?: SxProps;
}

type SidebarInputInnerProps = {
  stacklineTheme: StacklineTheme;
} & SidebarInputProps;

const SidebarInputInner = styled('input')<SidebarInputInnerProps>(({ stacklineTheme, style = {} }) => ({
  height: '24px',
  fontFamily: 'Roboto',
  fontWeight: '400',
  fontSize: '12px',
  border: 'none',
  padding: '0',
  borderBottom: `0.5px solid ${stacklineTheme.colors.primaryGray}`,
  color: stacklineTheme.colors.primary,

  '&::placeholder': {
    color: hexToRgba(stacklineTheme.colors.secondary, 0.5)
  },
  '&:focus': {
    outline: 'none'
  },
  '::placeholder': {
    color: hexToRgba(stacklineTheme.colors.secondary, 0.5)
  },
  ':disabled': {
    backgroundColor: 'white'
  },
  ...style
}));

// eslint-disable-next-line react/display-name
const SidebarInput = React.forwardRef((props: SidebarInputProps, ref: ForwardedRef<HTMLInputElement>): JSX.Element => {
  const theme = useStacklineTheme();
  return <SidebarInputInner maxLength={100} ref={ref} stacklineTheme={theme} {...props} />;
});

export default SidebarInput;
